import { useEffect, useMemo, useRef } from 'react';

import { useCoreDispatch } from '../../../../store/CoreStore';
import { useBetSlice } from '../../../../store/slices/bets/selectors';
import { useGameStateSlice } from '../../../../store/slices/game/selectors';
import { gameStateActions } from '../../../../store/slices/game/slice';

export const useLastWinDisplayConnected = (): number | null => {
  const winResult = useGameStateSlice.winResult();
  const lastWinAmountRef = useRef<number | null>(null);
  const totalBet = useBetSlice.totalBet();
  const isBetOpen = useGameStateSlice.isBetsOpenStatus();
  const dispatch = useCoreDispatch();
  const waitForWinResult = useGameStateSlice.getWaitForWinResult();
  const isBetPlaced = isBetOpen && totalBet > 0;

  useEffect(() => {
    if (isBetPlaced) {
      dispatch(gameStateActions.setWaitForWinResult(true));
    }
  }, [dispatch, isBetPlaced]);

  return useMemo(() => {
    if (isBetPlaced) {
      lastWinAmountRef.current = null;
    } else if (winResult?.amount) {
      lastWinAmountRef.current = winResult.amount;
    }
    return waitForWinResult ? null : lastWinAmountRef.current;
  }, [isBetPlaced, winResult, waitForWinResult]);
};
